import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=01f89b87&scoped=true&"
import script from "./Debt.vue?vue&type=script&lang=js&"
export * from "./Debt.vue?vue&type=script&lang=js&"
import style0 from "./Debt.vue?vue&type=style&index=0&id=01f89b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f89b87",
  null
  
)

export default component.exports